import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * Custom element for product extra info (barcode, size guide modal).
 * Listens for variant updates to change the barcode dynamically.
 */
class ProductExtraInfoComponent extends Component {
  requiredRefs = ['extraInfoContainer'];

  connectedCallback() {
    super.connectedCallback();

    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.addEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);

    // Size guide modal
    if (this.refs.sizeGuideBtn) {
      this.refs.sizeGuideBtn.addEventListener('click', this.openModal);
    }
    if (this.refs.modalClose) {
      this.refs.modalClose.addEventListener('click', this.closeModal);
    }
    if (this.refs.modalBackdrop) {
      this.refs.modalBackdrop.addEventListener('click', this.closeModal);
    }

    // Close modal on Escape key
    this._onKeyDown = (e) => {
      if (e.key === 'Escape') this.closeModal();
    };
    document.addEventListener('keydown', this._onKeyDown);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    const target = this.closest('[id*="ProductInformation-"], [id*="QuickAdd-"], product-card');
    if (!target) return;
    target.removeEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);

    document.removeEventListener('keydown', this._onKeyDown);
  }

  /**
   * Update barcode when variant changes.
   */
  onVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    }

    if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    if (event.detail.resource) {
      const variant = event.detail.resource;
      const barcode = variant.barcode || '';

      if (this.refs.barcode) {
        this.refs.barcode.textContent = barcode;
      }
      if (this.refs.barcodeRow) {
        this.refs.barcodeRow.style.display = barcode ? '' : 'none';
      }
    }
  };

  openModal = () => {
    if (!this.refs.sizeGuideModal) return;
    this.refs.sizeGuideModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  closeModal = () => {
    if (!this.refs.sizeGuideModal) return;
    this.refs.sizeGuideModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };
}

if (!customElements.get('product-extra-info-component')) {
  customElements.define('product-extra-info-component', ProductExtraInfoComponent);
}
